import { bindActionCreators } from 'redux';
import axios from '../../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const getAssignment = async (params) => {
  return await axios.get(`${baseURL}/assignment`, { params });
};

export const getVideo = async (params) => {
  return await axios.get(`${baseURL}/video`, { params });
};

export const getCertificate = async (params) => {
  return await axios.get(`${baseURL}/certificate`, { params });
};

export const getExercise = async (params) => {
  return await axios.get(`${baseURL}/exercise`, { params });
};

export const addAssignment = async (params) => {
  return await axios.post(`${baseURL}/assignment`, params);
};

export const addVideo = async (params) => {
  return await axios.post(`${baseURL}/video`, params);
};

export const addExercise = async (params) => {
  return await axios.post(`${baseURL}/exercise`, params);
};

export const addCertificate = async (params) => {
  return await axios.post(`${baseURL}/certificate`, params);
};

export const updateAssignment = async (params) => {
  return await axios.put(`${baseURL}/assignment`, params);
};

export const updateVideo = async (params) => {
  return await axios.put(`${baseURL}/video`, params);
};

export const updateExercise = async (params) => {
  return await axios.put(`${baseURL}/exercise`, params);
};

export const updateCertificate = async (params) => {
  return await axios.put(`${baseURL}/certificate`, params);
};
